(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const COLLECTION_RETURN_STATE_KEY = 'collection-return-state';
  const COLLECTION_RETURN_MAX_AGE_MS = 30 * 60 * 1000;

  const getNormalizedCollectionUrl = (url) => {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('page');
    parsedUrl.hash = '';
    return `${parsedUrl.pathname}${parsedUrl.search}`;
  };

  document.addEventListener(
    'DOMContentLoaded',
    async () => {
      const navigationEntry = performance.getEntriesByType('navigation')[0];
      const isBackForwardNavigation = navigationEntry?.type === 'back_forward';
      if (!isBackForwardNavigation) return;

      let state;
      try {
        state = JSON.parse(localStorage.getItem(COLLECTION_RETURN_STATE_KEY) || 'null');
      } catch {
        state = null;
      }

      if (!state?.collectionUrl) return;

      const now = Date.now();
      if (typeof state.savedAt !== 'number' || now - state.savedAt > COLLECTION_RETURN_MAX_AGE_MS) {
        try {
          localStorage.removeItem(COLLECTION_RETURN_STATE_KEY);
        } catch {
          // Ignore storage errors.
        }
        return;
      }

      if (state.collectionUrl !== getNormalizedCollectionUrl(window.location.href)) return;

      await customElements.whenDefined('results-list');
      const resultsList = document.querySelector('results-list[section-id]');
      if (!(resultsList instanceof HTMLElement)) return;
      if (typeof resultsList.restoreFromStoredState !== 'function') return;

      await resultsList.restoreFromStoredState(state);
      try {
        localStorage.removeItem(COLLECTION_RETURN_STATE_KEY);
      } catch {
        // Ignore storage errors.
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
